import { Injectable } from '@angular/core';
import { Constants } from '../constants/constants';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private env: EnvService) { }

  getVehicleLogo(vehicle): string {
    var logo = "assets/images/car-placeholder.png";
    var image = vehicle.logo;
    if (!image)
      image = vehicle.vehicleImage;
    if (!image || image == this.env.BASE_URL + "assets/images/1615468052551-nissan.png") {
      if (vehicle.make.toUpperCase() == "NISSAN") {
        logo = "assets/images/logo/nissan-next-logo-black.png"
      } else if (vehicle.make.toUpperCase() == "INFINITI") {
        logo = "assets/images/infiniti-logo-dark.png"
      }
    } else {
      logo = image;
    }
    return logo;
  }

}
